// extracted by mini-css-extract-plugin
module.exports = {"reviewItem":"ReviewsBlock_reviewItem__uhupR","wrapper":"ReviewsBlock_wrapper___LE4i"};